module.exports = __webpack_public_path__ + "img/img (22).c38e225a.png";